import {
  IdentifierCode,
  ServiceRequestPerformerIdentifier,
  system,
} from '../coding';
import { createCodeableConcept } from './coding';

type PerformerReference = Required<Pick<fhir4.Reference, 'identifier'>>;

/**
 * The performer to be used for performing ampath service requests
 */
export const ampathPerformerReference: PerformerReference = {
  identifier: {
    system,
    type: createCodeableConcept(IdentifierCode.serviceRequestPerformer),
    value: ServiceRequestPerformerIdentifier.Ampath,
  },
};

export const lancetPerformerReference: PerformerReference = {
  identifier: {
    system,
    type: createCodeableConcept(IdentifierCode.serviceRequestPerformer),
    value: ServiceRequestPerformerIdentifier.Lancet,
  },
};
